export default class ReadMore {
    allTextArray = [];
    currentText = '';
    currentArrayIndex = 0;
    initialCount = 5;
    batchSize = 10;
    allParagraphs = [];
    currentIndex = 0;


    init() {
        const container = this.$root.parentElement;
        this.allParagraphs = Array.from(container.querySelectorAll('p, ul')); // Select all paragraphs
        this.currentIndex = 0; // Tracks how many paragraphs have been revealed

        // Hide all paragraphs initially
        this.allParagraphs.forEach((p) => (p.style.display = 'none'));

        // Show the initial batch of paragraphs
        this.showInitialBatch();

        // Set up the button click logic
        // const button = this.$root.querySelector('button');
        // if (button) {
        //     button.addEventListener('click', (e) => {
        //         e.preventDefault();
        //         this.handleReadMoreClick(button);
        //     });
        // }
    }

    showInitialBatch() {
        const batchSize = Math.min(this.initialCount, this.allParagraphs.length);

        console.log('batchSize', this.initialCount);

        // Show the initial paragraphs
        for (let i = 0; i < batchSize; i++) {
            this.allParagraphs[i].style.display = 'block';
        }

        this.currentIndex += batchSize;
    }

    handleReadMoreClick(button) {
        const remainingParagraphs = this.allParagraphs.length - this.currentIndex;
        const remainingTextLength = this.calculateRemainingTextLength();

        // Show all remaining paragraphs if conditions are met
        if (remainingParagraphs <= this.batchSize && remainingTextLength < 200) {
            this.showAllRemaining();
            this.hideButton(button);
        } else {
            // Otherwise, show the next batch
            this.showNextBatch(button);
            if (this.currentIndex >= this.allParagraphs.length) {
                this.hideButton(button);
            }
        }
    }

    showNextBatch(button) {
        const remainingParagraphs = this.allParagraphs.length - this.currentIndex;
        const batchSize = Math.min(this.batchSize, remainingParagraphs);

        // Show the next batch of paragraphs
        for (let i = 0; i < batchSize; i++) {
            this.allParagraphs[this.currentIndex + i].style.display = 'block';
        }

        this.currentIndex += batchSize;

        const remainingTextLength = this.calculateRemainingTextLength();
        console.log('remainingTextLength', remainingTextLength);

        if(remainingTextLength < 200) {
            this.showAllRemaining();
            this.hideButton(button);
        }
    }

    calculateRemainingTextLength() {
        const remainingParagraphs = this.allParagraphs.slice(this.currentIndex);
        return remainingParagraphs.reduce((total, p) => total + p.textContent.length, 0);
    }

    showAllRemaining() {
        this.allParagraphs.slice(this.currentIndex).forEach((p) => (p.style.display = 'block'));
        this.currentIndex = this.allParagraphs.length;
    }

    hideButton(button) {
        button.style.display = 'none';
    }


}


document.addEventListener('alpine:init', () => {
    Alpine.data('readMore', () => new ReadMore());
});